import logo from './logo.svg';
import './App.css';
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from './store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loginpage from './Loginpage';
import { IatfProvider } from './Usecontext'; // Adjust this import path!
import Homepage from './Homepage';
import EnableMFA from './EnableMFA';
import Welcome from './Welcome';
import MFASetup from './MFASetup';
import Enable2FA from './Enable2FA';
import VerifyMFA from './VerifyMFA';
import Navbar from './Navbar';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        {/* Wrap everything with your context provider */}
        <IatfProvider>
          <Routes>
            <Route path="/" element={<Loginpage />} />
            <Route path="Homepage" element={<Homepage/>}/>
             <Route path="navbar" element={<Navbar/>}/>
            <Route path="enable-mfa" element={<EnableMFA />} />
            <Route path="welcome" element={<Welcome />} />
            <Route path="mfa-setup" element={<MFASetup />} />
            <Route path="enable-2fa" element={<Enable2FA />} />
            <Route path="verify-mfa" element={<VerifyMFA />} />
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </IatfProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;